import "../../styles/blocks/shopify-themes/benefits.scss";

import React, { useState } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

const benefitsIconWidths = {
  mobile: 12,
  customizable: 20,
  speed: 20,
  seo: 18,
  ada: 17,
  developer: 20,
}

const ShopifyThemesBenefits = ({ title, items, buttonText }) => {
  const [isActive, setIsActive] = useState(false)

  const benefitsClasses = classNames(
    "benefits container container--products-landing",
    {
      "is-active": isActive,
    }
  )
  const loadMoreClasses = classNames("benefits__button link", {
    hidden: isActive,
  })

  return (
    <section className="benefits-section">
      <div className={benefitsClasses}>
        {title ? <h2 className="benefits__title">{title}</h2> : null}

        <div className="benefits__row">
          {items.map(({ icon, title: itemTitle, text }) => {
            return (
              <div className="benefits__item" key={itemTitle}>
                <div className="benefits__item-icon">
                  {benefitsIconWidths[icon] ? (
                    <img
                      src={`/shopify-themes/icons/benefits-${icon}.svg`}
                      width={benefitsIconWidths[icon]}
                      height={20}
                      loading="lazy"
                      alt=""
                      aria-hidden="true"
                    />
                  ) : null}
                </div>

                <div className="benefits__item-container">
                  <h4 className="benefits__item-title">{itemTitle}</h4>

                  <p className="benefits__item-text">{text}</p>
                </div>
              </div>
            )
          })}
        </div>

        {buttonText && items.length > 3 ? (
          <button
            className={loadMoreClasses}
            type="button"
            aria-expanded={isActive}
            onClick={() => setIsActive(true)}
          >
            {buttonText}
          </button>
        ) : null}
      </div>
    </section>
  )
}

ShopifyThemesBenefits.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.oneOf(Object.keys(benefitsIconWidths)).isRequired,
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  buttonText: PropTypes.string,
}

export default ShopifyThemesBenefits
